function initModalSpanDialog() {
    $('#modal-span-dialog').on('shown.bs.modal', function (e) {
      updateSpanTable();
    });

    document.getElementById('add-left-span-button').addEventListener('click', () => {
        if(customerGate()) { 
            $('#modal-span-dialog').modal('toggle')
            return
        }
        addLeftSpan()
        autoBeamFlexureDesign()
    })

    document.getElementById('add-right-span-button').addEventListener('click', () => {
        if(customerGate()) { 
            $('#modal-span-dialog').modal('toggle')
            return
        }
        addLeftSpan()
        autoBeamFlexureDesign()
    })
}

function updateSpanTable() {
    var str = "<table class='table table-borderless'>";
    for( var i = 0; i < activeProject.beam.spans.length; i++ ) {
        var span_num = i + 1;
        str += "<tr>";
        str += "<td style='width:100px;'>Span "+ span_num + "</td>";
        str += "<td><input class='ws-ui-input-load new-span-input' style='width:100px;' id='span_input_"+i+"' type='text' name='new_span' ";
        str += "value='" + showLengthWithUnits(activeProject.beam.spans[i].length(), true) + "' onchange='updateSpan("+i+");'/></td>";
        if(activeProject.beam.spans.length > 1) {
            str += "<td><button type='button' class='btn btn-sm btn-danger' onclick='removeSpan("+i+");'>Remove</button></td>";
        }
        str += "</tr>"
    }
    str += "</table>";

    document.getElementById('span-table').innerHTML = str
    document.dispatchEvent(new CustomEvent('span-table-updated'))
}

function openModalSpanDialog(index) {
    $('#modal-span-dialog').modal('show');
    //put cursor in this input box if the id has been passed in
    if( typeof index !== undefined && index !== null ){
        //get this item's index
        if( index >= 0 && index < activeProject.beam.spans.length ) {
            $('#modal-span-dialog').on('shown.bs.modal', function () {
                document.getElementById(`span_input_${index}`).focus()
            });
        }
    }
}

function removeSpan(index) {
    if(BeamManager.removeSpan(activeProject, index)) {
        updateSpanTable()
    }
}

function addLeftSpan() {
    const length = activeProject.beam.spans[0].length();
    if(!isNaN(length) && BeamManager.addLeftSpan(activeProject, length)) {
        updateSpanTable();
        document.getElementById('span_input_0').focus();
    }
}

function addRightSpan() {
    const iEnd = activeProject.beam.spans.length;
    const length = activeProject.beam.spans[iEnd - 1].length();
    if(!isNaN(length) && BeamManager.addRightSpan(activeProject, length)){
        updateSpanTable();
        document.getElementById(`span_input_${iEnd}`).focus();
    }
}

function updateSpan( index ) {
    const spanId = `span_input_${index}`
    if(validateRequiredInput(spanId) && validateLengthInput(spanId)) {
        const length = wsParseLength(document.getElementById(spanId).value)
        BeamManager.modifySpan(activeProject, index, length)
        document.dispatchEvent(new CustomEvent('span-length-changed'))
    }
}
